export function parseTimestamp(v: any): number | null {
  if (v == null) return null;
  const n = typeof v === "string" && v.trim() !== "" ? Number(v) : v;
  if (typeof n !== "number" || Number.isNaN(n)) return null;
  return String(n).length === 10 ? n * 1000 : n;
}

export function getEventTimeCandidates(ev: any): number[] {
  const out: number[] = [];
  const keys = ["nextDate", "nextdate", "next_date"];
  for (const k of keys) {
    const ts = parseTimestamp(ev?.[k]);
    if (ts) out.push(ts);
  }
  if (Array.isArray(ev?.dates)) {
    ev.dates.forEach((d: any) => {
      const t = parseTimestamp(d);
      if (t) out.push(t);
    });
  }
  return Array.from(new Set(out)).sort((a, b) => a - b);
}

export function getNowSanDiego(): number {
  return new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" }),
  ).getTime();
}

export function isUpcomingOrInProgress(ev: any, now: number): boolean {
  const c = getEventTimeCandidates(ev);
  if (!c.length) return false;
  return c.some((t) => t >= now);
}

export function getNextAvailable(ev: any, now: number): number | null {
  const c = getEventTimeCandidates(ev).filter((t) => t >= now);
  return c.length ? c[0] : null;
}

export default {
  parseTimestamp,
  getEventTimeCandidates,
  getNowSanDiego,
  isUpcomingOrInProgress,
  getNextAvailable,
};
